import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PolicyPageComponent } from './policy-page/policy-page.component';
import { PartialModule } from '../partial/partial.module';

@NgModule({
  declarations: [
    PolicyPageComponent
  ],
  imports: [
    CommonModule,
    PartialModule
  ],
  exports: [
    PolicyPageComponent
  ]
})
export class PolicyModule { }
